export default "__VITE_ASSET__g5C5hC7C__"